// extracted by mini-css-extract-plugin
export default {"socialShare":"aOtczFkP","mobile":"mobile","rambler-share":"rambler-share","socialShareTitle":"DMKkhGsw","socialShareSocials":"H7jLMRNM","desktop":"desktop"};